import { Directive, TemplateRef, inject, input } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ng-template[cell]',
})
export class TableCellDirective {
  templateRef = inject<TemplateRef<unknown>>(TemplateRef);

  readonly cell = input<string>();

  readonly columnTitle = input<string>();

  readonly sortingDisabled = input(false);
}
